<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
      <h6 class="m-0 font-weight-bold text-primary">DATA PEGAWAI</h6>

      <div>
        <button class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" @click="newForm">
          <i class="fas fa-plus fa-sm text-white-50" />
          Tambah Pegawai
        </button>
      </div>

    </div>

    <div class="row">
      <div class="col">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="search" placeholder="Cari pegawai" @keyup.enter="onSearch" />

            <b-input-group-append>
              <b-button :disabled="!search" @click="onResetSearch">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="col">
        <div class="form-group">
          <v-select
            v-model="filter.employeeTypeID"
            :options="listOptions.employeeTypes"
            :reduce="item => item.ID"
            placeholder="Tipe Pegawai"
            @input="fetchData()"
            label="Name"/>
        </div>
      </div>

      <div class="col text-right">
        Total Pegawai: <strong>{{ totalItems }}</strong>
      </div>
    </div>

    <hr>

    <div class="row">
      <div v-for="item in tableItems" class="col-xs-12 col-md-6 mb-3">
        <div class="card card-employee shadow">
          <b-media no-body>
            <b-media-aside vertical-align="center">
              <img :src="$constant.baseURL + item.Photo" v-if="item.Photo" width="100" height="128">
              <img src="/images/employees/dummy-avatar.jpg" width="100" height="128" v-else>
            </b-media-aside>

            <b-media-body class="ml-2">
              <h6 class="mt-0 pt-2">{{ item.Name }}</h6>
              <hr>
              <p class="mb-0 pb-1">
                <span v-if="item.EmployeeAssignments.length">
                  {{ item.EmployeeAssignments[item.EmployeeAssignments.length - 1].PositionDetail.Position.Name }}
                </span>
                <br>

                <span v-if="item.EmployeeAssignments.length > 0">
                  TMT <strong>{{ $helper.formatDate(item.EmployeeAssignments[0].Start) }}</strong>
                </span>
                <br>
<!-- 
                <span v-if="item.EmployeeEducations.length">
                  Pendidikan 
                  <strong>
                    {{ item.EmployeeEducations[item.EmployeeEducations.length - 1].Education.Name }}
                  </strong>
                </span>
                <span v-else>
                  Pendidikan pegawai belum diisi
                </span>
-->
                 <div class="text-right mr-4">
                   <button class="btn btn-link m-0 p-0" @click="openDetail(item)">Detail</button> &nbsp;
                   <button class="btn btn-link text-danger m-0 p-0" @click="deleteItem(item.ID)">Hapus</button>
                 </div>

              </p>
            </b-media-body>
          </b-media>
        </div>
      </div>
    </div>

    <b-row class="mb-2">
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Tampilkan" class="mb-0">
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
            @change="onPageSizeChange" />
        </b-form-group>
      </b-col>

      <b-col md="4" class="my-1">
      </b-col>

      <b-col md="4" class="my-1">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          class="my-0"
          @change="onPageChange"
        ></b-pagination>
      </b-col>
    </b-row>

  </div>
</template>

<script>


export default {
  middleware: 'auth',
  mounted() {
    this.fetchData()

    this.fetchOptionData()
  },

  data() {
    return {
      tableItems: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30],
      search: '',
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      listOptions: {
        employeeTypes: []
      },
      filter: {
        employeeTypeID: null
      }
    }
  },

  methods: {
    fetchData () {
      this.$axios.get(`employee`, { params: {
        page: this.currentPage,
        pageSize: this.perPage,
        employeeType: this.filter.employeeTypeID,
        search: this.search
      }}).then((res) => {
        this.totalItems = res.data.total
        this.tableItems = res.data.rows
      }).catch(function (error) {
        console.log(error)
      })
    },

    onPageChange (page) {
      this.currentPage = page

      this.fetchData()
    },

    onPageSizeChange (val) {
      this.perPage = val

      this.fetchData()
    },

    onSearch () {
      this.fetchData()
    },

    onResetSearch () {
      this.search = ''

      this.fetchData()
    },

    newForm () {
      this.$store.commit('employee/selectEmployee', {
        isNew: true,
        data: {}
      })
      this.$router.push('/employee/form')
    },

    openDetail (data) {
      this.$router.push(`/employee/${data.ID}`)
      // this.$router.push({
      //   name: 'employee-detail',
      //   // params: { employeeData: data }
      // })
    },

    deleteItem (id) {
      Swal.fire({
        title: 'Anda yakin?',
        text: "Pegawai akan dihapus secara permanen!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Iya, Hapus saja!'
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(`/employee/${id}`).then(res => {
            this.fetchData()

            Swal.fire(
              'Terhapus!',
              'Data berhasil dihapus.',
              'success'
            )
          })
        }
      })
    },

    fetchOptionData () {
      this.$axios.get('/employee-type').then((res) => {
        this.listOptions.employeeTypes = res.data
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>

</style>